// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__c5oi9","rightContainer":"Dashboard_rightContainer__0-9Jy"};